import { useStoreLastReadEventIds } from '@/app/store/pinia/lastReadEventIds/lastReadEventIds'
import { useStoreRooms } from '@/app/store/pinia/rooms/rooms'
import { useStoreSettingsNotifications } from '@/app/store/pinia/settings/notifications'

import { useBlackWhiteListStore } from '@/entities/black-white-list'
import { useCurrentUserOtherTerminalSessionsStore, useCallSessionStartedTimestampStore } from '@/entities/call-session'
import { useCallSessionMediaStore } from '@/entities/call-session-media'
import { useCallsStore } from '@/entities/calls'
import { useStoreConferenceMediaStatuses, useConferenceAllowedParticipantsStore, useModeratedConferenceParticipantsSignalsStore } from '@/entities/conference-participant'
import { useStoreContacts } from '@/entities/contact'
import { useStoreGroups } from '@/entities/contact-group'
import { useStoreMediaDevices } from '@/entities/media-devices'
import { chatModel, draftModel, usePinEventsStore } from '@/entities/messages'
import { useStorePickupCall } from '@/entities/pickup-call'
import { useChatFilesMarkersStore } from '@/entities/room'
import { useRoomScheduleStore } from '@/entities/schedule'
import { useStoreProfile } from '@/entities/user-profile'

import { useStoreConfiguration } from '@/shared/store/configuration'
import { useStoreEnvSettings } from '@/shared/store/environment'
import { useRoomPublicIdentityStore } from '@/shared/store/public-identity'
import { useAppVersionStore } from '@/shared/store/version'

import { useCallRingingStore } from './calls/ringing'
import { useNotificationItemStore } from './notifications/items'
import { useNotificationPreferenceStore } from './notifications/preferences'
import { useTelProtocolNumberStore } from './tel-protocol-number'

export const useStore = () => ({
  groups: useStoreGroups(),
  configuration: useStoreConfiguration(),
  contacts: useStoreContacts(),
  rooms: useStoreRooms(),
  devices: useStoreMediaDevices(),
  appVersion: useAppVersionStore(),
  lastReadEvents: useStoreLastReadEventIds(),
  pickupCalls: useStorePickupCall(),
  envSettings: useStoreEnvSettings(),
  settingsNotifications: useStoreSettingsNotifications(),
  notificationItems: useNotificationItemStore(),
  notificationPreferences: useNotificationPreferenceStore(),
  profile: useStoreProfile(),
  chatMessages: chatModel.useChatMessageStore(),
  draftMessages: draftModel.useDraftMessageStore(),
  callRinging: useCallRingingStore(),
  telProtocolNumberStore: useTelProtocolNumberStore(),
  blackWhiteList: useBlackWhiteListStore(),
  calls: useCallsStore(),
  callSessionMedia: useCallSessionMediaStore(),
  conferenceMedia: useStoreConferenceMediaStatuses(),
  currentUserOtherTerminalSessions: useCurrentUserOtherTerminalSessionsStore(),
  pinEvents: usePinEventsStore(),
  callSessionStartedTimestamp: useCallSessionStartedTimestampStore(),
  chatFilesMarkers: useChatFilesMarkersStore(),
  allowedParticipants: useConferenceAllowedParticipantsStore(),
  moderatedConferenceParticipantsRequests: useModeratedConferenceParticipantsSignalsStore(),
  roomSchedule: useRoomScheduleStore(),
  publicIdentities: useRoomPublicIdentityStore(),
})
